import {
    css,
    DefaultTheme,
    FlattenInterpolation,
    ThemeProps,
} from 'styled-components';

/**
 * Media query for styled-components implementation.
 */
export const mediaBreakpoint = {
    /**
     * For screen size which is same or larger than the breakpoint size.
     * @param {string} breakpoint - Breakpoint size.
     */
    up: (breakpoint :'sm'|'md'|'lg'|'xl') : FlattenInterpolation<ThemeProps<DefaultTheme>> => css`
        ${({ theme }) => `@media (min-width: ${theme.Grid.Breakpoints[breakpoint]})`}
    `,
    /**
     * For screen size which is same or smaller than the breakpoint size.
     * @param {string} breakpoint - Breakpoint size.
     */
    down: (breakpoint :'sm'|'md'|'lg'|'xl') : FlattenInterpolation<ThemeProps<DefaultTheme>> => css`
        ${({ theme }) => `@media (max-width: ${theme.Grid.Breakpoints[breakpoint]})`}
    `,
};

